import { render, staticRenderFns } from "./Birthday.vue?vue&type=template&id=8eda6082&scoped=true&"
import script from "./Birthday.vue?vue&type=script&lang=ts&"
export * from "./Birthday.vue?vue&type=script&lang=ts&"
import style0 from "./Birthday.vue?vue&type=style&index=0&id=8eda6082&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eda6082",
  null
  
)

export default component.exports